import React from 'react';
import { type EmailRuleLine } from '~/api/data/triggers/email-summary';

export type HeroIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

export const SOURCE_ICON_CLASS = {
  accent: 'text-sky-600 dark:text-sky-400',
  neutral: 'text-neutral-500 dark:text-neutral-400'
};

export const FlowStep = (props: {
  label: string;
  icon: HeroIcon;
  iconClassName: string;
  children: React.ReactNode;
}) => (
  <li className="group relative flex gap-4 pb-6 last:pb-0">
    <div
      aria-hidden="true"
      className="absolute bottom-1 left-[1.125rem] top-10 w-px bg-neutral-200 group-last:hidden dark:bg-neutral-700"
    />
    <div className="flex size-9 flex-none items-center justify-center rounded-lg bg-neutral-100 dark:bg-neutral-700">
      <props.icon aria-hidden="true" className={`size-5 ${props.iconClassName}`} />
    </div>
    <div className="min-w-0 flex-1">
      <p className="m-0 text-xs font-semibold uppercase tracking-wide text-neutral-500 dark:text-neutral-400">
        {props.label}
      </p>
      <div className="mt-1 space-y-2 text-sm text-neutral-900 dark:text-white">
        {props.children}
      </div>
    </div>
  </li>
);

export const Chips = ({ items }: { items: string[] }) => (
  <div className="flex flex-wrap gap-1.5">
    {items.map((item) => (
      <span
        key={item}
        className="rounded-md bg-neutral-100 px-2 py-0.5 text-xs font-medium text-neutral-700 dark:bg-neutral-700 dark:text-neutral-300"
      >
        {item}
      </span>
    ))}
  </div>
);

export const RuleLines = ({ lines }: { lines: EmailRuleLine[] }) => (
  <ul className="m-0 list-disc space-y-1 pl-5">
    {lines.map((line, index) => (
      <li key={index}>
        {line.text}
        {line.children?.length ? <RuleLines lines={line.children} /> : null}
      </li>
    ))}
  </ul>
);
